import { Input } from "@brg/input";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { LabelRedStar } from "../../../designerEditView/styles";
import { GridRow } from "../styles";
import { FormLabel } from "../../../../modals/styles";
import { InputContainer } from "shared/pages/teams/TeamEditNew/components/fields/TextInput";
import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES } from "@brg/ui";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import styled from "styled-components";
import { css } from "styled-components";


const DropdownInputContainer = styled(InputContainer)<{ hideIndicator?: boolean, isMulti?: boolean }>`
  ${({isMulti}) => isMulti && css`
    .brg-input__control{
      height: auto !important;
      min-height: 48px !important;
    }
    .brg-input__multi-value {
      padding-top: 4px;
      padding-bottom: 4px;
    }

    input[readonly][aria-autocomplete="list"],
    input[readonly][tabindex="0"],
    input[id*="react-select"][id*="input"] {
      display: none !important;
      height: 0 !important;
      width: 0 !important;
      opacity: 0 !important;
      position: absolute !important;
      left: -9999px !important;
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      outline: none !important;
    }
    
    .brg-input__input-container {
      height: 0 !important;
      min-height: 0 !important;
      overflow: hidden !important;
    }
  
  `}
   ${props => props.hideIndicator && `
    .brg-input__dropdown-indicator {
      display: none !important;
    }
    
    `}
`
interface OptionType {
  value: string;
  label: string;
}

const FREE_TYPE_MODE =  {
  active: true,
  disable: false
}

interface DropdownFieldProps {
  input: any;
  meta: any;
  label: string;
  required?: boolean;
  options: OptionType[];
  placeholder?: string;
  freeTypeIndex?: number;
  isMulti?: boolean;
  [key: string]: any;
}

const DropdownField: FC<DropdownFieldProps> = ({
  input,
  input: {
    onChange,
    value: inputValue,
  },
  meta: {
    touched,
    error,
  },
  label,
  required,
  options,
  freeTypeIndex,
  placeholder,
  isMulti = false,
  ...rest
}) => {
  const [freeType, setFreeType] = useState(FREE_TYPE_MODE.disable)
  const currentValue = useMemo(() => {
    if (isMulti) {
      if (!Array.isArray(inputValue)) return [];
      return options.filter(({ value }) => inputValue.includes(value));
    }
    return options.find(({ value }) => value === inputValue) || '';
  }, [inputValue, isMulti, options]);

  const isFreeTypeMode = useMemo(() => {
    return freeType === FREE_TYPE_MODE.active
  } , [freeType])

  const hideIndicator = useMemo(() => {
    if (!isMulti || !Array.isArray(inputValue) || !Array.isArray(options)) {
      return false;
    }
    return inputValue.length === options.length;
  }, [isMulti, inputValue, options]);

  if (isFreeTypeMode) {
    return (
      <GridRow>
        <FlexBox 
          gy={16} 
          direction="column" 
          directionMobile="column"
        >
          <CommonInput 
            type={INPUT_TYPES.text}
            value={inputValue} 
            placeholder="Напишите свой вариант"
            onChange={(ev: React.BaseSyntheticEvent) => {
              onChange(ev.target.value);
              setFreeType(FREE_TYPE_MODE.active)
            }}
            required={required}
            label={label}
          />
          <ProjectAddButton
            text={'Отменить'}
            onClick={() => {
              setFreeType(FREE_TYPE_MODE.disable)
              onChange('');
            }} 
          />
        </FlexBox>
      </GridRow>
    )
  }
  
  return (
    <GridRow       
    isTeamEdit 
    fullWidth 
    mobileColumn>
      {label && <CommonLabel label={label} required={required} />}
      <DropdownInputContainer className="input-container" hideIndicator={isMulti && hideIndicator} isMulti={isMulti}>
        <Input.Dropdown
          options={options}
          value={currentValue}
          placeholder={placeholder}
          isMulti={isMulti}
          onChange={(item: any) => {
            if (isMulti) {
              const values = item ? item.map((i: any) => i.value) : [];
              onChange(values);
            } else {
              const idx = options?.findIndex(
                (i) => i?.value === item.value);
              if (idx === freeTypeIndex) {
                setFreeType(FREE_TYPE_MODE.active);
                onChange('')
                return
              }
              onChange(item.value)
            }
          }}
        />
      </DropdownInputContainer>
    </GridRow>
  )
}

export default DropdownField;import { Input } from "@brg/input";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { LabelRedStar } from "../../../designerEditView/styles";
import { GridRow } from "../styles";
import { FormLabel } from "../../../../modals/styles";
import { InputContainer } from "shared/pages/teams/TeamEditNew/components/fields/TextInput";
import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES } from "@brg/ui";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import styled from "styled-components";
import { css } from "styled-components";


const DropdownInputContainer = styled(InputContainer)<{ hideIndicator?: boolean, isMulti?: boolean }>`
  ${({isMulti}) => isMulti && css`
    .brg-input__control{
      height: auto !important;
      min-height: 48px !important;
    }
    .brg-input__multi-value {
      padding-top: 4px;
      padding-bottom: 4px;
    }

    input[readonly][aria-autocomplete="list"],
    input[readonly][tabindex="0"],
    input[id*="react-select"][id*="input"] {
      display: none !important;
      height: 0 !important;
      width: 0 !important;
      opacity: 0 !important;
      position: absolute !important;
      left: -9999px !important;
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      outline: none !important;
    }
    
    .brg-input__input-container {
      height: 0 !important;
      min-height: 0 !important;
      overflow: hidden !important;
    }
  
  `}
   ${props => props.hideIndicator && `
    .brg-input__dropdown-indicator {
      display: none !important;
    }
    
    `}
`
interface OptionType {
  value: string;
  label: string;
}

const FREE_TYPE_MODE =  {
  active: true,
  disable: false
}

interface DropdownFieldProps {
  input: any;
  meta: any;
  label: string;
  required?: boolean;
  options: OptionType[];
  placeholder?: string;
  freeTypeIndex?: number;
  isMulti?: boolean;
  [key: string]: any;
}

const DropdownField: FC<DropdownFieldProps> = ({
  input,
  input: {
    onChange,
    value: inputValue,
  },
  meta: {
    touched,
    error,
  },
  label,
  required,
  options,
  freeTypeIndex,
  placeholder,
  isMulti = false,
  ...rest
}) => {
  const [freeType, setFreeType] = useState(FREE_TYPE_MODE.disable)
  const currentValue = useMemo(() => {
    if (isMulti) {
      if (!Array.isArray(inputValue)) return [];
      return options.filter(({ value }) => inputValue.includes(value));
    }
    return options.find(({ value }) => value === inputValue) || '';
  }, [inputValue, isMulti, options]);

  const isFreeTypeMode = useMemo(() => {
    return freeType === FREE_TYPE_MODE.active
  } , [freeType])

  const hideIndicator = useMemo(() => {
    if (!isMulti || !Array.isArray(inputValue) || !Array.isArray(options)) {
      return false;
    }
    return inputValue.length === options.length;
  }, [isMulti, inputValue, options]);

  if (isFreeTypeMode) {
    return (
      <GridRow>
        <FlexBox 
          gy={16} 
          direction="column" 
          directionMobile="column"
        >
          <CommonInput 
            type={INPUT_TYPES.text}
            value={inputValue} 
            placeholder="Напишите свой вариант"
            onChange={(ev: React.BaseSyntheticEvent) => {
              onChange(ev.target.value);
              setFreeType(FREE_TYPE_MODE.active)
            }}
            required={required}
            label={label}
          />
          <ProjectAddButton
            text={'Отменить'}
            onClick={() => {
              setFreeType(FREE_TYPE_MODE.disable)
              onChange('');
            }} 
          />
        </FlexBox>
      </GridRow>
    )
  }
  
  return (
    <GridRow       
    isTeamEdit 
    fullWidth 
    mobileColumn>
      {label && <CommonLabel label={label} required={required} />}
      <DropdownInputContainer className="input-container" hideIndicator={isMulti && hideIndicator} isMulti={isMulti}>
        <Input.Dropdown
          options={options}
          value={currentValue}
          placeholder={placeholder}
          isMulti={isMulti}
          onChange={(item: any) => {
            if (isMulti) {
              const values = item ? item.map((i: any) => i.value) : [];
              onChange(values);
            } else {
              const idx = options?.findIndex(
                (i) => i?.value === item.value);
              if (idx === freeTypeIndex) {
                setFreeType(FREE_TYPE_MODE.active);
                onChange('')
                return
              }
              onChange(item.value)
            }
          }}
        />
      </DropdownInputContainer>
    </GridRow>
  )
}

export default DropdownField;